import { render, staticRenderFns } from "./kefuzhanwei.vue?vue&type=template&id=74fc1432&scoped=true"
import script from "./kefuzhanwei.vue?vue&type=script&lang=js"
export * from "./kefuzhanwei.vue?vue&type=script&lang=js"
import style0 from "./kefuzhanwei.vue?vue&type=style&index=0&id=74fc1432&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "74fc1432",
  null
  
)

export default component.exports